module.exports = __webpack_public_path__ + "static/media/pollution.d34f445a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/instore/icons/pollution.svg
// module id = 135
// module chunks = 0